module.exports = __webpack_public_path__ + "img/1440.83d96886.jpg";